import { render, staticRenderFns } from "./purchaseRequisition-convert-po.vue?vue&type=template&id=8a9ab35a"
import script from "./purchaseRequisition-convert-po.vue?vue&type=script&lang=js"
export * from "./purchaseRequisition-convert-po.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports